gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const breakpoint = () => window.innerWidth < 768;
const isTouchDevice = () => {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};

const sections = gsap.utils.toArray("#app>.shopify-section");
const menu = document.querySelector("nav.menu");

if (
  document.querySelector("#page-index") &&
  !isTouchDevice() &&
  !breakpoint()
) {
  const container = document.querySelector("#app");
  const footerMenu = document.querySelector("nav.footer-menu");
  const logo = document.querySelector("#logo");

  // Add index attribute for debugging or styling
  sections.forEach((section, i) => {
    section.setAttribute("data-section-index", i);
  });

  // Basic Setup
  gsap.set(container, {
    height: "100vh",
    overflow: "hidden",
  });

  gsap.set(sections, {
    height: "100vh",
    overflow: "hidden",
    opacity: 0,
  });

  // Navigation with Menu
  [menu, footerMenu].forEach((navMenu) => {
    if (navMenu) {
      const menuLinks = navMenu.querySelectorAll("a[href^='#']");
      menuLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
          const targetId = this.getAttribute("href").replace("#", "");
          const targetSection = document.querySelector(`#${targetId}`);
          if (targetSection) {
            e.preventDefault();
            gsap.to(window, {
              scrollTo: { y: targetSection, offsetY: 0 },
              duration: 1.2,
              ease: "power2.inOut",
            });
          }
        });
      });
    }
  });

  // Initial state for header/nav on load
  if (logo) {
    gsap.set(logo, { opacity: 0 });
    gsap.to(logo, {
      opacity: 1,
      delay: 0.5,
      duration: 1,
    });
  }
  if (menu) {
    gsap.set(menu, {
      opacity: 0,
      top: "calc(100% - 80px)",
      left: "40px",
      right: "40px",
    });
    gsap.to(menu, {
      opacity: 1,
      delay: 1,
      duration: 1,
    });
  }

  let currentSectionIndex = 0;
  handleSectionChange(0);

  // Scroll-triggered section pinning
  gsap.to(sections, {
    yPercent: -100 * (sections.length - 1),
    ease: "none",
    scrollTrigger: {
      trigger: container,
      pin: true,
      scrub: 1,
      end: () => "+=" + container.offsetHeight * (sections.length - 1),
      onUpdate: (self) => {
        const progress = self.progress;
        const sectionIndex = Math.round(progress * (sections.length - 1));

        if (sectionIndex !== currentSectionIndex) {
          currentSectionIndex = sectionIndex;
          handleSectionChange(sectionIndex);
        }

        sections.forEach((section, index) => {
          if (index !== sectionIndex) {
            section.classList.remove("active");
            gsap.to(section, {
              opacity: 0,
              duration: 0.8,
            });
          }
        });

        if (sections[sectionIndex]) {
          sections[sectionIndex].classList.add("active");
          gsap.to(sections[sectionIndex], {
            opacity: 1,
            scale: 1,
            duration: 1.2,
            delay: 0.1,
          });
        }
      },
    },
  });

  // Create individual ScrollTriggers for menu active state
  sections.forEach((section, index) => {
    ScrollTrigger.create({
      trigger: section,
      start: "top center",
      end: "bottom center",
      onEnter: () => setActiveMenu(index),
      onEnterBack: () => setActiveMenu(index),
    });
  });

  function setActiveMenu(index) {
    if (!menu) return;
    const menuLinks = menu.querySelectorAll("a[href^='#']");
    const activeId = sections[index].getAttribute("id");
    menuLinks.forEach((link) => {
      const href = link.getAttribute("href").replace("#", "");
      if (href === activeId) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });
  }

  // Section-based logo/menu behavior
  function handleSectionChange(sectionIndex) {
    // Play/Pause videos
    sections.forEach((section, idx) => {
      const video = section.querySelector("video");
      if (video) {
        if (idx === sectionIndex) {
          // Reset to start and play
          video.currentTime = 0;
          video.play().catch((err) => {
            console.warn("Autoplay failed:", err);
          });
        } else {
          video.pause();
        }
      }
    });

    // Key frames
    const isIntro = sectionIndex === 0;
    const isBlack = sectionIndex === 3;
    const isFooter = sectionIndex === 5;

    // Logs
    console.log("Section index:", sectionIndex);

    // States
    const logoDefault = {
      delay: 0,
      duration: 1,
      ease: "power2.inOut",
      opacity: 1,
      top: "40px",
      left: "40px",
      width: "200px",
      color: isBlack ? "black" : "red",
    };

    const menuDefault = {
      delay: 0,
      duration: 1,
      ease: "power2.inOut",
      opacity: 1,
      top: "40px",
      left: "auto",
      right: "40px",
      color: isBlack ? "black" : "red",
    };

    const logoIntro = {
      delay: 1,
      duration: 1,
      ease: "power2.inOut",
      opacity: 1,
      top: "40px",
      left: "40px",
      width: "calc(100% - 80px)",
      color: "red",
    };

    const menuIntro = {
      delay: 1,
      duration: 1,
      ease: "power2.inOut",
      opacity: 1,
      top: "calc(100% - 80px)",
      left: "40px",
      right: "40px",
      color: "red",
    };

    const hidden = {
      delay: 0.5,
      duration: 0.5,
      opacity: 0,
    };

    if (logo) {
      gsap.to(logo, isFooter ? hidden : isIntro ? logoIntro : logoDefault);
    }

    if (menu) {
      gsap.to(menu, isFooter ? hidden : isIntro ? menuIntro : menuDefault);
    }
  }

  // Wheel & keyboard navigation
  let isScrolling = false;
  let lastScrollTime = 0;
  const scrollCooldown = 2000;

  container.addEventListener(
    "wheel",
    (e) => {
      e.preventDefault();
      const currentTime = Date.now();
      if (!isScrolling && currentTime - lastScrollTime > scrollCooldown) {
        isScrolling = true;
        lastScrollTime = currentTime;
        const direction = e.deltaY > 0 ? 1 : -1;
        scrollToNextSection(direction);
        setTimeout(() => {
          isScrolling = false;
        }, scrollCooldown);
      }
    },
    { passive: false }
  );

  document.addEventListener("keydown", (e) => {
    const currentTime = Date.now();
    if (
      (e.key === "ArrowDown" || e.key === "ArrowRight") &&
      !isScrolling &&
      currentTime - lastScrollTime > scrollCooldown
    ) {
      e.preventDefault();
      isScrolling = true;
      lastScrollTime = currentTime;
      scrollToNextSection(1);
      setTimeout(() => {
        isScrolling = false;
      }, scrollCooldown);
    } else if (
      (e.key === "ArrowUp" || e.key === "ArrowLeft") &&
      !isScrolling &&
      currentTime - lastScrollTime > scrollCooldown
    ) {
      e.preventDefault();
      isScrolling = true;
      lastScrollTime = currentTime;
      scrollToNextSection(-1);
      setTimeout(() => {
        isScrolling = false;
      }, scrollCooldown);
    }
  });

  function scrollToNextSection(direction) {
    const currentScroll = window.pageYOffset;
    const targetScroll = currentScroll + direction * window.innerHeight;
    gsap.to(window, {
      scrollTo: targetScroll,
      duration: 1.2,
    });
  }

  // Detect and sync section on load
  window.addEventListener("load", () => {
    ScrollTrigger.refresh();

    const sections = document.querySelectorAll("[data-section-index]");
    let currentSection = sections[0];
    let minOffset = window.innerHeight;

    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      if (rect.top >= 0 && rect.top < minOffset) {
        minOffset = rect.top;
        currentSection = section;
      }
    });

    const index = parseInt(
      currentSection.getAttribute("data-section-index"),
      10
    );

    ScrollTrigger.clearScrollMemory();
    window.history.scrollRestoration = "manual";
  });
} else {
  // Add an active class to every section and handle animations with css
  sections.forEach((section, index) => {
    ScrollTrigger.create({
      trigger: section,
      start: "top center",
      end: "bottom center",
      onEnter: () => {
        // sections.forEach((s) => s.classList.remove("active"));
        section.classList.add("active");
      },
      // onEnterBack: () => {
      //   sections.forEach((s) => s.classList.remove("active"));
      //   section.classList.add("active");
      // },
    });
  });

  // Initial state for header/nav on load
  if (logo) {
    gsap.set(logo, { opacity: 0 });
    gsap.to(logo, {
      opacity: 1,
      delay: 0.5,
      duration: 1,
    });
  }
  if (menu) {
    gsap.set(menu, {
      opacity: 0,
    });
    gsap.to(menu, {
      opacity: 1,
      delay: 1,
      duration: 1,
    });
  }

  const menuLinks = menu ? menu.querySelectorAll("a[href^='#']") : [];
  menuLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href").replace("#", "");
      const targetSection = document.querySelector(`#${targetId}`);
      if (targetSection) {
        e.preventDefault();
        gsap.to(window, {
          scrollTo: { y: targetSection, offsetY: 0 },
          duration: 1.2,
          ease: "power2.inOut",
        });
      }
    });
  });
}

if (!document.querySelector("#page-index") && typeof window !== "undefined") {
  // Find all anchor links on the page (excluding those handled above)
  const anchorLinks = document.querySelectorAll("a[href^='#']:not([href='#'])");
  anchorLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href").replace("#", "");
      const targetSection = document.getElementById(targetId);
      if (targetSection) {
        e.preventDefault();
        gsap.to(window, {
          scrollTo: { y: targetSection, offsetY: 0 },
          duration: 1.2,
          ease: "power2.inOut",
        });
      }
    });
  });
}
